import React, { Dispatch, SetStateAction, useMemo } from 'react';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';
import { CompetitionBoardCardPreview } from '../../atoms';
import { CompetitionBoardCard } from '../../molecules';
import { ICompetitionMatches } from '../../templates/competition-board/competition-board';
import './competition-board-match-group.scss';

interface ICompetitionBoardMatchGroupClasses {
  competitionBoardMatchGroup: string;
  competitionBoardMatchPreview: string;
}

export interface ICompetitionBoardMatchGroup extends IComponent {
  matches: ICompetitionMatches[];
  setVisibleColumn: Dispatch<SetStateAction<number>>;
  columnIndex: number;
  trackingData?: {};
}

const classNames = (): ICompetitionBoardMatchGroupClasses =>
  makeClassNames({
    competitionBoardMatchGroup: 'competition-board-match-group',
    competitionBoardMatchPreview: 'competition-board-match-preview',
  }) as ICompetitionBoardMatchGroupClasses;

const CompetitionBoardMatchGroup: React.FC<ICompetitionBoardMatchGroup> = ({
  matches,
  setVisibleColumn,
  columnIndex,
  trackingData,
}) => {
  const cn = useMemo(() => classNames(), []);

  return (
    <React.Fragment>
      {matches.map((match, index) => {
        if (index % 2 === 0) {
          const nextMatch = matches[index + 1];

          if (!nextMatch) {
            return (
              <CompetitionBoardCard
                needConnector={columnIndex !== 0}
                key={index}
                // onPreviewClick={() => setVisibleColumn(columnIndex - 1)}
                {...match}
                trackingData={trackingData}
              />
            );
          }

          return (
            <div key={index} className={cn.competitionBoardMatchGroup} data-competition-board-match-group>
              <CompetitionBoardCard
                needConnector={columnIndex !== 0}
                // onPreviewClick={() => setVisibleColumn(columnIndex - 1)}
                {...match}
                trackingData={trackingData}
              />
              {nextMatch && (
                <CompetitionBoardCard
                  needConnector={columnIndex !== 0}
                  // onPreviewClick={() => setVisibleColumn(columnIndex - 1)}
                  {...nextMatch}
                  trackingData={trackingData}
                />
              )}
              {match.nextMatch && (
                <div className={cn.competitionBoardMatchPreview}>
                  <CompetitionBoardCardPreview
                    needConnector={columnIndex !== 0}
                    // onClick={() => setVisibleColumn(columnIndex + 1)}
                    {...match.nextMatch}
                    trackingData={trackingData}
                  />
                </div>
              )}
            </div>
          );
        }
        return null;
      })}
    </React.Fragment>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  CompetitionBoardMatchGroup.propTypes = {};
}

export default CompetitionBoardMatchGroup;
